import {Injectable} from '@angular/core';
import {
  IColumnStyles,
  RUBICS_CUBE_COLUMNS,
  TRubicCubeValue,
  TStatusColumnValue
} from 'src/app/editor-interface/models/column-styles.interface';

@Injectable()
export class CustomViewColumnStylesService {
  public getStyles(column: TRubicCubeValue, value: any): IColumnStyles | undefined {
    switch (column) {
      case RUBICS_CUBE_COLUMNS.STATUS_COLUMN:
        return this.getStatusColumnStyles(value);
      case RUBICS_CUBE_COLUMNS.TAGS:
        return this.getTagsColumnStyles(value);
    }
  }

  private getStatusColumnStyles(value: TStatusColumnValue): IColumnStyles | undefined {
    return {classes: [`node-status ${value} no-resize`]};
  }

  private getTagsColumnStyles(value: TStatusColumnValue): IColumnStyles | undefined {
    return value && {classes: 'q9-tag-cell'};
  }
}
